import type {CSSProperties} from 'react';
import {radius, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeBlipClientLook = 'blip-client-copy' | 'blip-client-link' | 'blip-client-link-off';

const BLIP_CLIENT_LOOKS = new Set<string>(['blip-client-copy', 'blip-client-link', 'blip-client-link-off']);
export const isWedgeBlipClientLook = (look: string): look is WedgeBlipClientLook => BLIP_CLIENT_LOOKS.has(look);

/* Released Blip client action card draft footer (Wedge). Both looks are the shared pill of the prototype (`pillBtn`) with the compact padding of
   6px by 12px and 12px type. `blip-client-copy` is the idle pill (a 0.5px separator border, a transparent fill, the primary ink). `blip-client-link`
   is the filled pill (no border, the accent fill, the on-accent ink) that the card draws as a link with no underline; `blip-client-link-off` is the
   same link at half opacity and with no pointer events, for a lead with no email or phone. The primary and idle pills at full size are the
   `blip-plan-primary` look. The declaration order is the order of the source. The caller owns the label, the href, the handler and the row.
   No look draws a transparent target (the `blip-` hit rule removes it): the three controls sit in one wrapping row 8px apart, so a 44px region
   would overlap its neighbor. */
const COMPACT_PADDING = '6px 12px', COMPACT_FONT = 12;

export function wedgeBlipClientStyle(look: WedgeBlipClientLook): CSSProperties {
  const r = wedgeExactRole;
  if (look === 'blip-client-copy') return {
    padding: COMPACT_PADDING, borderRadius: radius.md, border: `0.5px solid ${r('separator')}`, background: 'transparent', color: r('label'),
    fontSize: COMPACT_FONT, fontWeight: weight.bold, cursor: 'pointer',
  };
  return {
    padding: COMPACT_PADDING, borderRadius: radius.md, border: 'none', background: r('accent'), color: r('onAccent'),
    fontSize: COMPACT_FONT, fontWeight: weight.bold, cursor: 'pointer', textDecoration: 'none',
    opacity: look === 'blip-client-link' ? 1 : 0.5, pointerEvents: look === 'blip-client-link' ? 'auto' : 'none',
  };
}
